// // PermissionRowAction.jsx
// import React from "react";
// import { Edit, Trash2 } from "lucide-react";
// import { deletePermission } from "../../../api/settings/permissions/permissionList";
// import { showConfirmDialog, showSuccessToast, showErrorToast } from "../../../components/ConfirmDialog";

// const RowAction = ({ data, onEdit, onDeleted }) => {
//   const handleDelete = async () => {
//     const confirm = await showConfirmDialog({ title: "Xác nhận xóa", text: "Bạn chắc chắn muốn xóa quyền này?" });
//     if (confirm.isConfirmed) {
//       try {
//         await deletePermission(data.code);
//         showSuccessToast("Đã xóa thành công");
//         onDeleted();
//       } catch (err) {
//         showErrorToast("Lỗi khi xóa");
//       }
//     }
//   };
//   return (
//     <div className="flex gap-2">
//       <button onClick={onEdit}><Edit size={18} className="text-yellow-600" /></button>
//       <button onClick={handleDelete}><Trash2 size={18} className="text-red-600" /></button>
//     </div>
//   );
// };

// export default RowAction;



// =============================
// File: PermissionRowAction.jsx
// =============================
import React from "react";
import { Edit, Trash2 } from "lucide-react";
import { deletePermission } from "../../../api/settings/permissions/permissionList";
import { showSuccessToast, showErrorToast } from "../../../components/ConfirmDialog";
import { confirmDelete, DELETE_ENTITY } from "../../../utils/confirmDelete";

const RowAction = ({ data, onEdit, onDeleted }) => {
  const handleDelete = async () => {
    const confirm = await confirmDelete({
      type: DELETE_ENTITY.permission,
      name: data?.name || data?.code,
    });
    if (confirm.isConfirmed) {
      try {
        await deletePermission(data.code);
        showSuccessToast("Đã xóa thành công");
        onDeleted();
      } catch (err) {
        showErrorToast("Lỗi khi xóa");
      }
    }
  };
  return (
    <div className="flex gap-2">
      <button onClick={onEdit} aria-label="Edit permission">
        <Edit size={18} className="text-yellow-600" />
      </button>
      <button onClick={handleDelete} aria-label="Delete permission">
        <Trash2 size={18} className="text-red-600" />
      </button>
    </div>
  );
};

export default RowAction;